import script from "./DiscoverPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscoverPage.vue?vue&type=script&setup=true&lang=js"

import "./DiscoverPage.vue?vue&type=style&index=0&id=7b316d72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b316d72"]])

export default __exports__